<template>
    <div
        class="container"
        id="model_index"
    >
        <section>
            <h3 class="title">
                {{$t('webstars.header_following')}}
            </h3>
            <ModelsContainer
                :following="true"
                :resultsPerPage="resultsPerPage"
            />
        </section>

        <section>
            <h3 class="title">
                {{$t('webstars.header_to_following')}}
            </h3>
            <ModelsContainer
                :following="false"
                :resultsPerPage="resultsPerPage"
            />
        </section>
    </div>
</template>
<script>
import ModelsContainer from "../ModelsContainer"
import _ from "lodash";
import EventBus from "../../eventbus";

export default {
    name: 'Webstars',
    components: {ModelsContainer},
    data(){
        return {
            resultsPerPage: 18,
            loading:false,
        };
    },
    mounted(){
        window.addEventListener('scroll', this.loadMoreForInfiniteScroll);
    },
    methods: {
        // proper implementation - do not use arrow function // debounce o throttle
        endOfScrollPageReached:_.throttle(function(){
            EventBus.$emit('webstarEndOfScrollPageReached');
            this.loading = false;
        }, 500),
        loadMoreForInfiniteScroll() {
            let currentPosition = document.documentElement.scrollTop + window.innerHeight;
            let tara            = 900; //(this.perPage * .4) * (window.innerHeight*.9)
            let positionToReach = document.documentElement.offsetHeight - tara;
            let bottomOfWindow  = currentPosition > positionToReach;
            if (bottomOfWindow && !this.loading) {
                this.loading = true;
                this.endOfScrollPageReached();
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadMoreForInfiniteScroll);
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

#model_index {
    background-color: var(--pallete_clear_color);
    min-height: 500px;
    padding: 9px;
    
    .title{
        border-top: unset;
    }
}
</style>